<template>
  <StageScaler>
    <BufferVideoStage
      data-testid="buffer-video-stage"
      :logo="theme_obj.logo_url"
      :demoButtonText="theme_obj.demo_request_button_text"
      :showDemoLink="theme_obj.demo_link_enabled"
      videoSource="https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8"
      :fillerSlide="{ url: fillerSlideURL, show: currentModuleId === 'fillerSlide' }"
      :targets="currentTargets"
      :navigatorLinks="navigatorLinks"
      :stageChatTabs="stageChatTabs"
      :sidebarPrimaryTabs="sidebarPrimaryTabs"
    />
  </StageScaler>
</template>

<script lang="ts">
import { BufferVideoStage } from '@goldcast/uicomponents-branding';
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';

import StageScaler from './StageScaler.vue';

import { STATIC_ASSETS } from '@/constants';
import {
  FillerSlideAsset,
  getFillerSlideAssets
} from '@/studio/studioLibrary/fillerSlideLibrary/fillerSlideLibraryService';

export default defineComponent({
  name: 'BufferVideoStagePreview',
  components: { StageScaler, BufferVideoStage },
  data() {
    return {
      fillerSlideAssets: [] as FillerSlideAsset[]
    };
  },
  mounted() {
    if (this.currentModuleId === 'fillerSlide') {
      getFillerSlideAssets({}).then(res => {
        this.fillerSlideAssets = res.assets;
      });
    }
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData',
      theme_obj: 'theme_obj',
      currentTargets: 'currentTargets',
      navigatorLinks: 'navigatorLinks',
      stageChatTabs: 'stageChatTabs',
      sidebarPrimaryTabs: 'sidebarPrimaryTabs'
    }),
    ...mapGetters('studioEventList', { event: 'getCurrentEvent' }),
    ...mapState('branding', { currentModuleId: 'currentModuleId' }),
    fillerSlideURL(): string {
      if (this.currentModuleId !== 'fillerSlide') {
        return '';
      }

      const moduleKeys = ['filler_slide'];
      const { filler_slide } = this.getInitialModuleData(moduleKeys);
      const path = this.fillerSlideAssets?.find(asset => asset.id === filler_slide)?.broadcast_filler_image_s3_path;

      return path ? `${STATIC_ASSETS.CLOUDFRONT_URL}/${path}` : '';
    }
  }
});
</script>
